import { createFileRoute } from '@tanstack/react-router'
import { BRAND_FALLBACK } from '@/components/marketing/config'
import { Landing } from '@/components/marketing/Landing'

export const Route = createFileRoute('/')({
  head: () => ({
    meta: [
      { title: `${BRAND_FALLBACK}: your WordPress site rebuilt, same design, fast and secure` },
      {
        name: 'description',
        content:
          'We rebuild your WordPress site with the same design on a fast, secure platform and give you a simple editor. Free audit, free homepage preview, fixed price. Your email stays untouched.',
      },
    ],
  }),
  component: Landing,
})
